import React from "react";
import { FilterFieldAmountRange } from "./FilterFieldAmountRange";
import { FilterFieldCheckbox } from "./FilterFieldCheckbox";
import { FilterFieldDateRage } from "./FilterFieldDateRage";
import { FilterFieldInput } from "./FilterFieldInput";
import { FilterFieldRadio } from "./FilterFieldRadio";
import { FilterFieldSelect } from "./FilterFieldSelect";
import { useInternalState } from "./InternalContext";
import {
  WSFilter,
  WSFilterAmountRangeValue,
  WSFilterDateRangeValue,
  WSFilterMultiValue,
  WSFilterSingleValue
} from "./types";

export const FilterField: React.FC<WSFilter> = (props) => {
  const { values, onChange } = useInternalState();

  switch (props.type) {
    case "checkbox":
      return (
        <FilterFieldCheckbox
          name={props.name}
          options={props.options || []}
          value={values[props.name] as WSFilterMultiValue | undefined}
          onChange={onChange}
        />
      );
    case "radio":
      return (
        <FilterFieldRadio
          name={props.name}
          options={props.options || []}
          value={values[props.name] as WSFilterSingleValue | undefined}
          onChange={onChange}
        />
      );
    case "daterange":
      return (
        <FilterFieldDateRage
          name={props.name}
          options={props.options || []}
          value={values[props.name] as WSFilterDateRangeValue | undefined}
          onChange={onChange}
        />
      );
    case "input":
      return (
        <FilterFieldInput
          name={props.name}
          value={values[props.name] as WSFilterSingleValue | undefined}
          onChange={onChange}
          placeholder={props.placeholder}
        />
      );
    case "amountrange":
      return (
        <FilterFieldAmountRange
          name={props.name}
          value={values[props.name] as WSFilterAmountRangeValue | undefined}
          onChange={onChange}
        />
      );
    case "select":
      return (
        <FilterFieldSelect
          name={props.name}
          options={props.options || []}
          value={values[props.name] as WSFilterSingleValue | undefined}
          onChange={onChange}
        />
      );
    default:
      return null;
  }
};
